module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./UserRelateView.js"));
	}, "userRelateView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=userRelateView!./src/pages/RoleMgmt/UserRelate/UserRelateView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=userRelateView!./src/pages/RoleMgmt/UserRelate/UserRelateView.js
// module chunks = 43